"use strict";

export const initGsap = async () => {

    let gsap, ScrollTrigger; // Declare variables for wider scope within initGsap

    try {
        // Load Core and ScrollTrigger first as they are widely used
        const [gsapModule, scrollTriggerModule] = await Promise.all([
            import('gsap'),
            import('gsap/ScrollTrigger')
        ]);

        gsap = gsapModule.default;
        ScrollTrigger = scrollTriggerModule.ScrollTrigger; // Assuming named export

        // Register ScrollTrigger immediately
        gsap.registerPlugin(ScrollTrigger);

    } catch (error) {
        console.error("Failed to load GSAP Core or ScrollTrigger:", error);
        return; // Can't proceed without these
    }
    
	initGsapAos(gsap, ScrollTrigger)
    toggleVideoIfOnScreen(ScrollTrigger, '.home-about video')
	init404Gsap(gsap, ScrollTrigger, '.banner--404')
};

/**
|--------------------------------------------------
| Toggle play/pause on a video if it's on screen
|--------------------------------------------------
*/

export const toggleVideoIfOnScreen = function(ScrollTrigger, selector) {
    const video = document.querySelector(selector);
    if(!video) return;
    ScrollTrigger.create({
        //markers: true,
        trigger: video,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => video.play(),
        onEnterBack: () => video.play(),
        onLeaveBack: () => video.pause(),
        onLeave: () => video.pause()
    });
}

/**
|--------------------------------------------------
| AOS-alike animations with GSAP and ScrollTrigger
|--------------------------------------------------
*/

export const initGsapAos = (gsap, ScrollTrigger) => {
	const elements = gsap.utils.toArray("[data-aos]");
	if (!elements.length) return;

	ScrollTrigger.batch(elements, {
		//markers: true,
		start: (self) => self.trigger.dataset.aosAnchorPlacement || "top 80%",
		end: "+=100",
		once: true,
		onEnter: (batch) => {
			batch.forEach((element, index) => {
				const animationType = element.dataset.aos || "fade";
				const delay = element.dataset.aosDelay ? parseFloat(element.dataset.aosDelay) / 1000 : 0;
				const duration = element.dataset.aosDuration ? parseFloat(element.dataset.aosDuration) / 1000 : 1;

				let fromConfig = { opacity: 0 };

				// Assign movement based on animation type
				switch (animationType) {
					case "fade-up":
						fromConfig.y = 50;
						break;
					case "fade-down":
						fromConfig.y = -50;
						break;
					case "fade-right":
						fromConfig.x = -50;
						break;
					case "fade-left":
						fromConfig.x = 50;
						break;
					default:
						break; // "fade" only modifies opacity
				}

				gsap.fromTo(
					element,
					fromConfig,
					{
						opacity: 1,
						y: 0,
						x: 0,
						duration: duration,
						delay: delay + index * 0.2, // Batch stagger effect
					}
				);
			});
		}
	});
};

export const init404Gsap = (gsap, ScrollTrigger, selector) => {
	const section = document.querySelector(selector);
	if(!section) return;
	const grid = section.querySelector('.grid-404');
	if(!grid) return;
	const svgs = grid.querySelectorAll('svg');
	// Odd svgs are for mobile, even for desktop
	const title = section.querySelector('.banner__title');
	const description = section.querySelector('.banner__description');
	const buttonWrapper = section.querySelector('.btn')?.parentElement;

	const tl = gsap.timeline({})
	.from(title, { opacity: 0, y: 50, duration: 1 })
	.from(description, { opacity: 0, y: 50, duration: 1 }, "-=70%")
	.from(buttonWrapper, { opacity: 0, y: 50, duration: 1 }, "-=70%")
	.from(svgs[0], { opacity: 0, y: -50, duration: 1 }, "<25%")
	.from(svgs[1], { opacity: 0, x: -50, duration: 1 }, "<")
	.from(svgs[2], { opacity: 0, y: 50, duration: 1 }, "<")
	.from(svgs[3], { opacity: 0, x: 50, duration: 1 }, "<")


	ScrollTrigger.create({
		trigger: section,
		start: 'top 80%',
		end: "+=100",
		once: true,
		onEnter: () => {
			tl.play();
		}
	});
}